import { motion } from 'framer-motion';
import type { ButtonHTMLAttributes } from 'react';

type Variant = 'primary' | 'secondary' | 'outline' | 'danger' | 'ai';
type Size = 'sm' | 'md';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  isGenerating?: boolean;
}

const VARIANT_CLASS: Record<Variant, string> = {
  primary: 'btn-primary',
  secondary: 'btn-secondary',
  outline: 'btn-outline',
  danger: 'btn-danger',
  ai: 'btn-ai',
};

export default function Button({
  variant = 'primary', size = 'md', isGenerating = false,
  className = '', children, disabled, ...rest
}: ButtonProps) {
  const classes = [
    'btn',
    VARIANT_CLASS[variant],
    size === 'sm' ? 'btn-sm' : '',
    variant === 'ai' && isGenerating ? 'is-generating' : '',
    className,
  ].filter(Boolean).join(' ');

  return (
    <motion.button
      className={classes}
      disabled={disabled}
      whileTap={disabled ? undefined : { scale: 0.97 }}
      transition={{ duration: 0.1 }}
      {...(rest as any)}
    >
      {children}
    </motion.button>
  );
}
